import type { BrandName } from '@/scopes/common/domain/types'
import { formatISO } from 'date-fns'
import { isActiveBooking } from '@/scopes/account/common/utils/bookingDates'

export function isEligibleForExcursions(
  brandName: BrandName,
  isCancelled: boolean,
  rawDepartureDate: string,
  rawReturnDate: string,
  now: Date = new Date(),
): boolean {
  return brandName !== 'eliza'
    && isActiveBooking(rawDepartureDate, rawReturnDate, isCancelled, now)
}

export function getExcursionsStartDate(rawDepartureDate: string, today = formatISO(new Date(), { representation: 'date' })): string {
  return rawDepartureDate >= today ? rawDepartureDate : today
}
